import referrerApi from '../../api/referrer'

// initial state
const state = {
  referrers: []
}

const getters = {
}

const actions = {
  getReferrers ({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      referrerApi.getAll(referrers => {
        commit('setReferrers', referrers)
        resolve(referrers)
      },
      error => {
        reject(error)
      })
    })
  },

  createReferrer ({ commit }, newReferrer) {
    return new Promise((resolve, reject) => {
      referrerApi.create(newReferrer, referrer => {
        commit('addReferrer', referrer)
        resolve(referrer)
      },
      error => {
        reject(error)
      })
    })
  },

}

const mutations = {
  setReferrers(state, referrers) {
    state.referrers = referrers
  },

  addReferrer(state, referrer) {
    state.referrers.push(referrer)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
